import request from '@/utils/request'

export function getRoomsByStoreId(storeId) {
  return request({
    url: '/api/Extend/LqMdRoom/GetByStoreId',
    method: 'get',
    data: { storeId }
  })
}
